import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const prostate: AnswerPathTreeNode = {
  path: 'prostate',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredProstateDetails }],
};
